import { userConstants } from "../constants/login.constants";

 function beneficialOwner(state = {}, action) {
    switch (action.type) {
        case userConstants.BENEFICIALOWNER_REQUEST:
            return {
                loading: true
            };
        case userConstants.BENEFICIALOWNER_SUCCESS:
            return {
                items: action.beneficialOwner
            };
        case userConstants.BENEFICIALOWNER_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default beneficialOwner;